<template>
  <div :class="item.class" class="flex w-full space-x-2">
    <template v-if="Array.isArray(item.value)">
      <div class="w-1/5 text-label">{{ item.label }}</div>
      <div class="text-headline">
        <div v-for="value in item.value" :key="value" class="value">
          {{ value }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="w-1/5 text-label">{{ item.label }}</div>
      <div class="value text-headline">{{ item.value }}</div>
    </template>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  item: {
    label: string;
    value: string | string[];
    class?: string;
  };
}>();
</script>
